import { PUBLISHING_CHANNEL_MODEL } from "@/models/publishing-channel-model";

export const PUBLISHING_SCHEDULE_MODEL = "publishing-schedule";

const publishingScheduleModel = {
  tierName: "",
  publishOnDate: "",
  state: "",
  cost: 0,
  currencyCode: "",
  url: "",
  receiver: {
    jsonApi: "hasOne",
    type: PUBLISHING_CHANNEL_MODEL
  },
  booking: {
    jsonApi: "hasOne",
    type: "booking"
  }
};

export default publishingScheduleModel;
